import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";

const ErrorModal = ({ open, count, filesUndefined, onClose }) => {
  const [openCollapse, setOpenCollapse] = React.useState(false);

  const handleClick = () => {
    setOpenCollapse(!openCollapse);
  };

  const firstFile = filesUndefined[0];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <DialogTitle id="error-modal-title">
        Erro ao processar arquivos
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="error-modal-description">
          {count > 1
            ? `Há ${count} arquivos com campos indefinidos.`
            : "Há um arquivo com campos indefinidos."}
        </DialogContentText>

        {firstFile && (
          <div>
            <p>
              {`Arquivo ${firstFile.index} com campos indefinidos: `}
              <strong>{firstFile.colunas.join(", ")}</strong>
            </p>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
